/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import WidgetWithChart from '../../common/WidgetWithChart';
import PreparedChart from './PreparedChart';
import IntlMessages from "../../../../../util/IntlMessages";

const QueriesWithLowCTR = ({ lostOpportunities }) => {
  const { isFetched, isFetching, queries, curve, error } = lostOpportunities;
  const dataIsReady = isFetching || !isFetched;
  const mainNumber = error || !(queries && queries.filteredTotal)
    ? '-'
    : queries.filteredTotal;

  return (
    <WidgetWithChart
      isFetching={dataIsReady}
      title={<IntlMessages id="analytics.lowCtr.title" />}
      mainNumber={mainNumber}
      description={<IntlMessages id="analytics.lowCtr.description" />}
      chart={<PreparedChart data={curve && curve.data} />}
      tone="lostOpportunities"
    />
  );
};

QueriesWithLowCTR.propTypes = {
  lostOpportunities: PropTypes.shape({
    isFetched: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    queries: PropTypes.shape({
      total: PropTypes.any.isRequired,
    }),
    curve: PropTypes.shape({
      data: PropTypes.any.isRequired,
    }),
  }).isRequired,
};

export default QueriesWithLowCTR;
